import WelcomeTour from './WelcomeTour';
import TourInit from './TourInit';
import OnboardingFinish from './OnboardingFinish';
import HomeTour from './HomeTour';
import HomeFinish from './HomeFinish';
import ClientsTour from './ClientsTour';
import ClientsFinish from './ClientsFinish';
import ConstructionsFormTour from './ConstructionsFormTour';
import ConstructionsFormFinish from './ConstructionsFormFinish';
import PayablesTour from './PayablesTour';
import PayablesFinish from './PayablesFinish';
import BudgetsTour from './BudgetsTour';
import BudgetsFinish from './BudgetsFinish';
import SchedulesTour from './SchedulesTour';
import SchedulesFinish from './SchedulesFinish';
import PhotosTour from './PhotosTour';
import PhotosFinish from './PhotosFinish';
import DocumentsTour from './DocumentsTour';
import DocumentsFinish from './DocumentsFinish';
import DashboardTour from './DashboardTour';
import DashboardFinish from './DashboardFinish';
import SuppliersTour from './SuppliersTour';
import SuppliersFinish from './SuppliersFinish';
import CategoriesTour from './CategoriesTour';
import CategoriesFinish from './CategoriesFinish';
import NewReleaseTour from './NewReleaseTour';
import NewReleaseFinish from './NewReleaseFinish';

export const homeTutorial = [
  WelcomeTour,
  TourInit,
  OnboardingFinish,
  HomeTour,
  HomeFinish,
  ClientsTour,
  ClientsFinish,
  ConstructionsFormTour,
  ConstructionsFormFinish,
  PayablesTour,
  PayablesFinish,
  BudgetsTour,
  BudgetsFinish,
  SchedulesTour,
  SchedulesFinish,
  PhotosTour,
  PhotosFinish,
  DocumentsTour,
  DocumentsFinish,
  DashboardTour,
  DashboardFinish,
  SuppliersTour,
  SuppliersFinish,
  CategoriesTour,
  CategoriesFinish,
  NewReleaseTour,
  NewReleaseFinish,
];
